import FullScreenActionBackground from '../layouts/components/FullScreenActionBackground/FullScreenActionBackground'
import { ReactNode } from 'react'
import { Header } from '@/layouts/errors/Header'

export default function ThemeLangOutlet(props: { children: React.ReactNode; header?: ReactNode }) {
  return <FullScreenActionBackground header={props.header ?? <Header />}>{props.children}</FullScreenActionBackground>
}
